import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const PromoactionsLazy = loadable(() => import(/* webpackChunkName: "Promoactions" */ './PromoactionsSuspense'));

export const PromoactionsAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <PromoactionsLazy />
    </DelayedSuspense>
);
